import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { BodyText } from 'palette/Typography';
import { useTranslation } from '@common/Hooks/useTranslation';
import ListingContext from '@common/Listing/ListingContext';

interface ProductsCountInfoProps {
    categoryName: string;
    className?: string;
}

export default function ProductsCountInfo({ className, categoryName }: ProductsCountInfoProps) {
    const translate = useTranslation();
    const { hasProducts } = useContext(ListingContext);
    // @ts-ignore
    const productsCount = useSelector(({ listing }) => listing.productsCount);

    return (
        <div className={className}>
            {
                !hasProducts && (
                    <BodyText
                        className="mr-16"
                        level="2"
                    >
                        {translate('listing.all.headline')}
                        {' '}
                        {categoryName}
                    </BodyText>
                )
            }
            {
                (hasProducts && productsCount) && (
                    <BodyText
                        color="light"
                        level="2"
                    >
                        {translate('listing.paging.total{%num%}styles', { num: productsCount })}
                    </BodyText>
                )
            }
        </div>
    );
}
